// --------------
// STATE

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FileItemInfo } from '../sic-lib/types/FileItemInfo';

export interface MediaState {
    mediaDrawer: boolean;
    selectedMedia: FileItemInfo[];
    maxAttachmentReached: boolean;
}

const initialState: MediaState = {
    mediaDrawer: false,
    selectedMedia: [],
    maxAttachmentReached: false,
};

const mediaSlice = createSlice({
    name: 'media',
    initialState,
    reducers: {
        setMediaDrawer: (state, action: PayloadAction<{ mediaDrawer: boolean }>) => {
            const { mediaDrawer } = action.payload;
            state.mediaDrawer = mediaDrawer;
        },
        cleanMediaDrawer: state => {
            state.mediaDrawer = false;
            state.selectedMedia = [];
            state.maxAttachmentReached = false;
        },
        addSelectedMedia: (state, action: PayloadAction<{ selectedMedia: FileItemInfo[] }>) => {
            const { selectedMedia } = action.payload;
            state.selectedMedia = [...state.selectedMedia, ...selectedMedia];
        },
        removeSelectedMedia: (state, action: PayloadAction<{ fileName: string }>) => {
            const { fileName } = action.payload;
            state.selectedMedia = state.selectedMedia.filter(media => media.fileName !== fileName);
        },
        setMaxAttachmentReached: (
            state,
            action: PayloadAction<{ maxAttachmentReached: boolean }>,
        ) => {
            const { maxAttachmentReached } = action.payload;
            state.maxAttachmentReached = maxAttachmentReached;
        },
    },
});

export const {
    setMediaDrawer,
    cleanMediaDrawer,
    addSelectedMedia,
    removeSelectedMedia,
    setMaxAttachmentReached,
} = mediaSlice.actions;

export default mediaSlice.reducer;
